export default "__VITE_PUBLIC_ASSET__3c51f429__"